import {useState} from 'react';

import {CollapsedMatchInformation} from './CollapsedMatchInformation';
import {MatchInformationOverview} from './MatchInformationOverview';
import {MatchData} from '../../../../../../../types/shared-recruiting-types';

interface Props {
  data: MatchData;
}

export const MatchInformation = ({data}: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <MatchInformationOverview
        onClick={() => setOpen(!open)}
        open={open}
        matchDataInfo={data.matchInformationOverview}
      />
      <CollapsedMatchInformation open={open} data={data} />
    </>
  );
};
